import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from '../stores/auth';
import { uniq } from 'lodash';
import dayjs from 'dayjs';

export const contractsStore = defineStore('contracts-store', {
    state: () => {
        return {
            allContracts: '',
            pendingSignatureContracts: [],
        };
    },

    getters: {
        contracts(state) {
            return state.allContracts;
        },
        getDisctricts(state) {
            return uniq(
                state.allContracts.map((c) => {
                    return c.rentalObject.district;
                })
            );
        },
    },

    actions: {
        async fetchContracts() {
            const response = await axios.get(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me/rentcontracts',
                authStore().authConfig
            );
            try {
                this.allContracts = response.data;
            } catch (err) {
                this.allContracts = '';
                console.error('Error loading Contracts:', err);
                return err;
            }
        },

        async terminationRequest(contractNumber, earliestMoveOutDate) {
            const desiredMoveDate = earliestMoveOutDate
                ? earliestMoveOutDate.split('T')[0] + 'T00:00:00'
                : dayjs().add(3, 'month').endOf('month').format('YYYY-MM-DD') + 'T00:00:00';

            try {
                const response = await axios.post(
                    process.env.VUE_APP_API_BASE_URL + 'applicants/me/rentContracts/terminationRequest',
                    {
                        contractNumber: contractNumber,
                        desiredMoveDate: desiredMoveDate,
                    },
                    { ...authStore().authConfig, validateStatus: () => true }
                );

                if (response.status === 204) {
                    if (!this.pendingSignatureContracts.includes(contractNumber)) {
                        this.pendingSignatureContracts.push(contractNumber);
                    }
                    await this.fetchContracts();
                    return { ok: true };
                }

                if ([400, 404, 409].includes(response.status)) {
                    return { ok: false, message: response.data?.detail };
                }

                return { ok: false };
            } catch (err) {
                console.error('Failed to terminate contract:', err);
                return { ok: false };
            }
        },
    },
});
